import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { sharedEnvironment } from "../../config";
import { type KeyPaths, mapToCopyFileCare, mapToCopyFilePortal, mapToCopyFileWebshop } from "../../infra/locales";

const appName = sharedEnvironment.appName;
const maps = {
  care: mapToCopyFileCare,
  portal: mapToCopyFilePortal,
  webshop: mapToCopyFileWebshop,
};

const _mapToCopyFile = maps[appName];

export type CopyFile = ReturnType<typeof _mapToCopyFile>;
export type CopyKeyPortal = ReturnType<(typeof maps)["portal"]>;
export type CopyKeyCare = ReturnType<(typeof maps)["care"]>;
export type CopyKey = KeyPaths<CopyFile>;

type LocaleCopyStore = {
  isLoadingLocaleCopy: boolean;
  setIsLoadingLocaleCopy: (value: boolean) => void;
  localeCopy: CopyFile | null;
  setLocaleCopy: (newCopy: CopyFile) => void;
}

export const useLocaleCopyStore = create<LocaleCopyStore>()(
  persist(
    set => ({
      isLoadingLocaleCopy: true,
      setIsLoadingLocaleCopy: (value: boolean) => set({ isLoadingLocaleCopy: value }),
      localeCopy: null,
      setLocaleCopy: (newCopy: CopyFile) =>
        set({
          localeCopy: newCopy,
        }),
    }),
    {
      name: "locale-copy",
      version: 2,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
